// Product page - product description 'show more' link
(function() {
  const showMoreLink = document.querySelector('.description__show-more-btn');
  const showMoreContent = document.querySelector('#showMore');
  if(showMoreLink && showMoreContent) {
    const rect = showMoreContent.getBoundingClientRect();
    const scrollOffset = window.scrollY + rect.top - 160;
    showMoreLink.addEventListener('click', (event) => {
      event.preventDefault();
      showMoreContent.classList.toggle('expand');
      if (!showMoreContent.classList.contains("expand")) {
        window.scrollTo({ top: scrollOffset, behavior: "instant" });
      }
    });
  }

})();

// scroll to links
(function(){
  const scrollToLinks = document.querySelectorAll('.scroll-to-link');
  const scrollTopAdjustment = window.matchMedia('(min-width: 750px)').matches
                    ? 110
                    : 150
  scrollToLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      console.log(event)
      let targetSelector = event.target.attributes.href.value;
      let targetElement = document.querySelector(targetSelector);
      let top = window.pageYOffset + targetElement.getBoundingClientRect().top;
      window.scroll({
        top: top - scrollTopAdjustment, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  });
})();

// Product page - scroll to reviews
(function(){
  const scrollToReviews = document.querySelector('.product:not(.featured-product) .rating-wrapper');
  const scrollTopAdjustment = window.matchMedia('(min-width: 750px)').matches
                    ? 280
                    : 150
  if (scrollToReviews) {
    scrollToReviews.addEventListener('click', (event) => {
      event.preventDefault();
      let top = window.pageYOffset + document.querySelector('#collapsibleReviewsSection').getBoundingClientRect().top;
      window.scroll({
        top: top - scrollTopAdjustment, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  }
})();

// desktop sidebar menu - open megamenu on click
(function() {
  const topLevelLinks = document.querySelectorAll('.main-sidebar__has-megamenu > .main-sidebar__menu-item');
  topLevelLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const currentlyOpen = document.querySelector('.main-sidebar__has-megamenu > .main-sidebar__menu-item.open');
      if (currentlyOpen && currentlyOpen == link) {
        window.location.href = link.href;
      } else if (currentlyOpen) {
        currentlyOpen.classList.remove('open');
        link.classList.add('open');
      } else {
        link.classList.toggle('open');
      }
    });
  });
})();
// Close megamenu on click everywhere except the menu
document.addEventListener('click', function(e) {
  const clickedInsideMegamenu = event.target.closest('.main-sidebar__has-megamenu');
  if (!clickedInsideMegamenu) {
    const currentlyOpen = document.querySelector('.main-sidebar__has-megamenu > .main-sidebar__menu-item.open');
    if (currentlyOpen) {
      currentlyOpen.classList.remove('open');
    }
  }
});

// Tooltip
(function() {
  const tooltipContainers = document.querySelectorAll('.has-tooltip');
  tooltipContainers.forEach((tc) => {
    tc.addEventListener('click', () => {
      const currentActiveTooltip = document.querySelector('.has-tooltip.active');
      if (currentActiveTooltip) {
        currentActiveTooltip.classList.remove('active');
      }
      tc.classList.toggle('active');
    });
    // Close the tooltip if the user clicks close button
    tc.querySelector('.tooltip-close').addEventListener('click', function(event) {
      event.target.closest('.has-tooltip').classList.remove('active');
      event.stopPropagation();
    });
  });
  // Close the tooltip if the user clicks anywhere else on the page
  document.addEventListener('click', function(event) {
    const currentActiveTooltip = document.querySelector('.has-tooltip.active');
    if (currentActiveTooltip && !currentActiveTooltip.contains(event.target)) {
      currentActiveTooltip.classList.remove('active');
    }
  });
  // Close the tooltip if the user presses the Escape key
  document.addEventListener('keydown', function(event) {
    const currentActiveTooltip = document.querySelector('.has-tooltip.active');
    if (event.key === 'Escape' && currentActiveTooltip) {
      currentActiveTooltip.classList.remove('active');
    }
  });
})();

// Product page - sync product media slider with the slider in popup
(function(){
  const productMainSlider = document.querySelector('.product-media-gallery--custom slideshow-component');
  const productPopupSlider = document.querySelector('.product-media-modal--custom slider-component[id^="GalleryViewer"]');

  // mobile
  if (productMainSlider && productPopupSlider) {
    // Forward sync: Main → Popup
    productMainSlider.addEventListener('slideChanged', (event) => {
      const { currentPage } = event.detail;
      if (productPopupSlider.sliderItemOffset) {
        const scrollPosition = (currentPage - 1) * productPopupSlider.sliderItemOffset;
        productPopupSlider.setSlidePosition(scrollPosition);
      }
    });
  }
  
  // desktop
  const productMainSliderDesktop = document.querySelector('.small-hide media-gallery slider-component');
  if (productMainSliderDesktop && productPopupSlider) {
    // Forward sync: Main → Popup
    productMainSliderDesktop.addEventListener('slideChanged', (event) => {
      const { currentPage } = event.detail;
      if (productPopupSlider.sliderItemOffset) {
        const scrollPosition = (currentPage - 1) * productPopupSlider.sliderItemOffset;
        productPopupSlider.setSlidePosition(scrollPosition);
      }
    });
  }
})();

// Product page - sticky ATC
(function(){
  const stickyATC = document.querySelector('.product-sticky-atc');
  const mainATC = document.querySelector('.product__info-container .product-form__submit');
  const stickyATCimage = document.querySelector('.product-sticky-atc__image');

  if (stickyATC && mainATC) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
          stickyATC.classList.add('show');
        } else {
          stickyATC.classList.remove('show');          
        }
      });
    }, { threshold: 1 });
    observer.observe(mainATC);
  }

  // image click to scroll up
  if (stickyATCimage) {
    stickyATCimage.addEventListener('click', () => {
      let top = window.pageYOffset + document.querySelector('product-info').getBoundingClientRect().top;
      window.scroll({
        top: top - 150, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  }
})();

// wishlist button
(function(){
  const wishlistBtns = document.querySelectorAll('.wishlist-button');
  const wishlisHeaderIconBubble = document.querySelector('.wishlist-count-bubble');

  // handle button click
  document.addEventListener('click', function(event) {
    if (event.target.matches('.wishlist-button')) {
      let btn = event.target;
      let productHandle = btn.dataset.productHandle;
      if (btn.classList.contains('added')) {
        removeFavorite(productHandle);
        btn.classList.remove('added');
      } else {
        addFavorite(productHandle);
        btn.classList.add('added');
      }
    }
  });

  // update header wishlist icon bubble
  document.addEventListener('DOMContentLoaded', () => {
    var favoriteProducts = getFavoriteProducts();
    updateIconBubble(favoriteProducts.length);
  });

  // switch button state for added products
  document.addEventListener('DOMContentLoaded', () => {
    let favoriteProducts = getFavoriteProducts();
    wishlistBtns.forEach(btn => {
      let productHandle = btn.dataset.productHandle;
      let index = favoriteProducts.findIndex( p => p == productHandle);
      if (index > -1) {
        btn.classList.add('added');
      }
    });
  });

  function updateIconBubble(count) {
    wishlisHeaderIconBubble.innerHTML = count ? count : '';
  }

  function getFavoriteProducts() {
    var favoriteProducts = [];
    var storage = localStorage.favoriteProducts;
    if (storage) {
      favoriteProducts = JSON.parse(storage);
    }
    return favoriteProducts;
  }

  function addFavorite(productHandle) {
    var favoriteProducts = getFavoriteProducts();
    var index = favoriteProducts.findIndex( p => p == productHandle);
    if (index > -1) {
      favoriteProducts.splice(index, 1);
    }
    favoriteProducts.unshift(productHandle);
    localStorage.favoriteProducts = JSON.stringify(favoriteProducts);
    updateIconBubble(favoriteProducts.length);
  }

  function removeFavorite(productHandle) {
    var favoriteProducts = getFavoriteProducts();
    var index = favoriteProducts.findIndex( p => p == productHandle);
    if (index > -1) {
      favoriteProducts.splice(index, 1);
    }
    localStorage.favoriteProducts = JSON.stringify(favoriteProducts);
    updateIconBubble(favoriteProducts.length);
  }
})();

// 'Last visited' section
(function () {
  const lastVisitedSection = document.querySelector('.last-visited');
  const products = getRecentlyViewedProducts();

  if (lastVisitedSection && products.length) {
    let templateParam;
    if (lastVisitedSection.classList.contains('last-visited--product-page')) {
      templateParam = '?view=last-visited-product-card'
    } else {
      templateParam = '?view=last-visited-product-card-quick-add'
    }
    const prodURLs = products.map(
      p => location.origin + '/products/' + p + templateParam
    );

    fetchHTML(prodURLs).then(contents => {
      const productsList = lastVisitedSection.querySelector('.product-grid');
      const slider = lastVisitedSection.querySelector('slider-component');

      contents.forEach((html, i) => {
        if (!html) return; // skip nulls (failed fetches)

        const card = html.querySelector('.card-wrapper');
        if (!card) return; // skip if card not found

        const li = document.createElement('li');
        li.appendChild(card); // directly append the card element
        li.className = 'grid__item slider__slide';
        li.id = `Slide-${productsList.dataset.id}-${i + 1}`;
        productsList.appendChild(li);
      });

      if (lastVisitedSection.classList.contains('last-visited--product-page')) {
        const actualCount = productsList.querySelectorAll('li').length;
        if (actualCount > 2) {
          productsList.classList.add('slider', 'slider--tablet', 'grid--peek');
        }
        if (actualCount > 4) {
          productsList.classList.add('slider--desktop');
          slider.classList.add('slider-component-desktop', 'draggable-scroll');
          initSliderComponentDraggableScroll(slider);
        }
        if (actualCount <= 4) {
          lastVisitedSection.querySelector('.slider-buttons')?.classList.add('hidden');
        }
        if (actualCount <= 2) {
          slider.classList.add('page-width');
        }
        slider?.resetPages();
      } else {
        // limit to 10 products
        while (productsList.children.length > 10) {
          productsList.removeChild(productsList.lastElementChild);
        }
      }

      lastVisitedSection.classList.remove('hidden');
    });
  }

  function getRecentlyViewedProducts() {
    let viewedProducts = [];
    const storage = localStorage.recentlyViewedProducts;
    if (storage) {
      viewedProducts = JSON.parse(storage);
    }
    return viewedProducts;
  }

  function removeRecentlyViewedProduct(product) {
    let viewedProducts = getRecentlyViewedProducts();
    const updatedViewedProducts = viewedProducts.filter(p => p !== product);
    localStorage.setItem('recentlyViewedProducts', JSON.stringify(updatedViewedProducts));
  }

  async function fetchHTML(urls) {
    return await Promise.all(
      urls.map(async (url) => {
        try {
          const res = await fetch(url);
          if (!res.ok) {
            console.warn(`Skipped ${url}: ${res.status} ${res.statusText}`);
            if (res.status == 404) {
              const handle = url.match(/\/products\/([^/?]+)/)?.[1];
              removeRecentlyViewedProduct(handle);
            }
            return null;
          }

          const htmlText = await res.text();
          const wrapper = document.createElement('div');
          wrapper.innerHTML = htmlText;
          return wrapper;
        } catch (error) {
          console.warn(`Fetch error on ${url}:`, error);
          return null;
        }
      })
    );
  }
})();

// FAQs
document.addEventListener('DOMContentLoaded', () => {
  const faq = document.querySelector('.js-faq');
  if (!faq) return;

  const headings = [...faq.querySelectorAll('h2')];

  headings.forEach((h2, index) => {
    const accordion = document.createElement('div');
    const summary = document.createElement('summary');
    const accordionPanel = document.createElement('div');
    const accordionContent = document.createElement('div');

    h2.classList.add('h3');
    summary.innerHTML = h2.outerHTML + '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg>';
    summary.setAttribute('role', 'button');

    accordion.classList.add('animated-accordion');
    accordion.appendChild(summary);

    accordionPanel.classList.add('animated-accordion__panel');

    accordionContent.classList.add('animated-accordion__content', 'rte');

    let next = h2.nextElementSibling;
    while (next && next.tagName !== 'H2') {
      const toMove = next;
      next = next.nextElementSibling;
      accordionContent.appendChild(toMove);
    }

    accordionPanel.appendChild(accordionContent);

    accordion.appendChild(accordionPanel);
    h2.replaceWith(accordion);
  });
});

// animated accordion
document.addEventListener('click', function(event) {
  if (event.target.matches('.animated-accordion summary') || event.target.matches('.animated-accordion summary h2')) {
    event.preventDefault();
    const item = event.target.closest('.animated-accordion');
    const panel = item.querySelector('.animated-accordion__panel');
    const isOpen = item.classList.contains('active');
    if (isOpen) {
      item.classList.remove('active');
      panel.style.maxHeight = 0;
    } else {
      item.classList.add('active');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  }
});

// Collection page Load more button
(function () {
  document.querySelector('.js-load-more')?.addEventListener('click', function () {
    const button = this;

    const totalPages = parseInt(document.querySelector('[data-total-pages]').value, 10);
    let currentPage = parseInt(document.querySelector('[data-current-page]').value, 10);

    button.setAttribute('disabled', 'true');
    button.querySelector('[load-more-text]')?.classList.add('hidden');
    button.querySelector('[loader]')?.classList.remove('hidden');

    currentPage += 1;

    const nextUrl = document.querySelector('[data-next-url]').value.replace(/page=\d+/, 'page=' + currentPage);
    document.querySelector('[data-current-page]').value = currentPage;

    fetch(nextUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.text())
      .then(responseHTML => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseHTML;
        const newItems = tempDiv.querySelector('.product-grid')?.innerHTML;
        if (newItems) {
          document.querySelector('.product-grid').insertAdjacentHTML('beforeend', newItems);
        }
      })
      .finally(() => {
        if (currentPage < totalPages) {
          button.removeAttribute('disabled');
          button.querySelector('[load-more-text]')?.classList.remove('hidden');
          button.querySelector('[loader]')?.classList.add('hidden');
        } else {
          button.classList.add('hidden');
        }
      });
  });

})();

// Product page Load more button
(function () {
  document.querySelector('.js-load-more--pdp')?.addEventListener('click', function () {
    const button = this;

    const totalPages = parseInt(document.querySelector('[data-total-pages]').value, 10);
    let currentPage = parseInt(document.querySelector('[data-current-page]').value, 10);

    button.setAttribute('disabled', 'true');
    button.querySelector('[load-more-text]')?.classList.add('hidden');
    button.querySelector('[loader]')?.classList.remove('hidden');

    currentPage += 1;

    const nextUrl = document.querySelector('[data-next-url]').value.replace(/page=\d+/, 'page=' + currentPage);
    document.querySelector('[data-current-page]').value = currentPage;

    fetch(nextUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(response => response.text())
      .then(responseHTML => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseHTML;
        const newItems = tempDiv.querySelector('.product-grid')?.innerHTML;
        if (newItems) {
          document.querySelector('.collection--unavailable-shop-more .product-grid').insertAdjacentHTML('beforeend', newItems);
        }
      })
      .finally(() => {
        if (currentPage < totalPages) {
          button.removeAttribute('disabled');
          button.querySelector('[load-more-text]')?.classList.remove('hidden');
          button.querySelector('[loader]')?.classList.add('hidden');
        } else {
          button.classList.add('hidden');
        }
      });
  });

})();

// prevent menu hover when scrolling pdp images with mouse grab
document.addEventListener('mousedown', (e) => {
  // add class to body, to prevent hover over menu while scrolling pdp slider
  if (e.target.matches('.draggable-scroll .product__media-toggle')) {
    document.querySelector('body').classList.add('scrolling');
  }
});
document.addEventListener('mouseup', (e) => {
  // remove class from body
  document.querySelector('body').classList.remove('scrolling');
});
    
// slider-component draggable scroll for desktop (generated with AI)
if (window.matchMedia('(min-width: 1025px)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    const dragSliderComponents = document.querySelectorAll('slider-component.draggable-scroll');
    dragSliderComponents.forEach((sliderComponent) => {
      initSliderComponentDraggableScroll(sliderComponent);
    });
  });
}
function initSliderComponentDraggableScroll(sliderComponent) {
  if (!sliderComponent) return;

  const sliderElement = sliderComponent.querySelector('ul.slider'); // The UL element
  // Attempt to get instance data if needed (adjust based on theme)
  const sliderInstance = sliderComponent.sliderController || sliderComponent;

  if (!sliderElement) return;

  // --- State Variables ---
  let isDown = false;
  let isDragging = false;
  let startX = 0;
  let scrollLeftStart = 0; // scrollLeft value when drag started
  let itemOffset = 0; // Calculated distance between items
  let rafId = null; // For requestAnimationFrame
  let immediateScrollLeft = 0; // Store target scrollLeft for RAF

  function calculateItemOffset() {
    const items = sliderElement.querySelectorAll(':scope > li.grid__item');
    let firstVisibleItem = null;
    let secondVisibleItem = null;
    for (let item of items) {
      if (item.offsetWidth > 0) { // Check if item is actually visible/rendered
        if (firstVisibleItem === null) {
          firstVisibleItem = item;
        } else {
          secondVisibleItem = item;
          break; // Found the first two visible items
        }
      }
    }

    if (secondVisibleItem) {
      return secondVisibleItem.offsetLeft - firstVisibleItem.offsetLeft;
    } else if (firstVisibleItem) {
      return firstVisibleItem.offsetWidth; // Fallback if only one item
    }
    return sliderElement.clientWidth; // Fallback if no items or calculation fails
  }

  // Initial calculation
  itemOffset = calculateItemOffset();
  // Recalculate on resize (debounced)
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => { clearTimeout(timeout); func(...args); };
      clearTimeout(timeout); timeout = setTimeout(later, wait);
    };
  };
  const debouncedRecalculateOffset = debounce(() => { itemOffset = calculateItemOffset(); }, 250);
  const resizeObserver = new ResizeObserver(debouncedRecalculateOffset);
  resizeObserver.observe(sliderElement);


  // --- Event Listeners ---
  sliderElement.addEventListener('mousedown', (e) => {
    // Prevent drag start on interactive elements if desired
    // if (e.target.closest('button, a[href]')) return;

    isDown = true;
    isDragging = false;
    startX = e.pageX - sliderElement.offsetLeft; // Adjust startX relative to the element
    scrollLeftStart = sliderElement.scrollLeft; // Store scroll position at start
    immediateScrollLeft = scrollLeftStart; // Initialize immediate target
    sliderElement.classList.add('grabbing'); // Sets cursor and scroll-behavior: auto
    if (rafId) cancelAnimationFrame(rafId); // Cancel pending frames
    rafId = null;
    // Do NOT preventDefault here - allows normal clicks if no drag occurs
  });

  sliderElement.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    // Prevent default text selection *only* if dragging starts
    e.preventDefault();

    const x = e.pageX - sliderElement.offsetLeft;
    const walk = (x - startX); // How far mouse moved frommousedown point

    // Check drag threshold only once
    if (!isDragging && Math.abs(walk) > 5) {
      isDragging = true;
    }

    if (isDragging) {
      // Calculate target scroll position
      immediateScrollLeft = scrollLeftStart - walk; // Scroll left moves opposite to mouse drag

      // Schedule update within animation frame for smoothness
      if (!rafId) {
        rafId = requestAnimationFrame(() => {
          sliderElement.scrollLeft = immediateScrollLeft;
          rafId = null; // Reset RAF ID
          // No heavy updates here
        });
      }
    }
  });

  function finishDrag() {
    if (!isDown) return; // Ensure executed only once
    isDown = false;
    sliderElement.classList.remove('grabbing'); // Restore smooth scroll behavior
    if (rafId) { cancelAnimationFrame(rafId); rafId = null; } // Clean up animation frame

    const wasDragging = isDragging; // Capture state before reset

    // Delay reset for click prevention
    setTimeout(() => { isDragging = false; }, 0);

    if (wasDragging) {
      // Calculate where to snap smoothly
      itemOffset = calculateItemOffset(); // Ensure offset is up-to-date
      if (itemOffset > 0) {
        const currentScroll = sliderElement.scrollLeft; // Use final scroll position
        const targetIndex = Math.round(currentScroll / itemOffset);
        let targetScrollLeft = targetIndex * itemOffset;

        // *** CLAMPING ***: Ensure target is within valid scroll bounds
        const maxScrollLeft = sliderElement.scrollWidth - sliderElement.clientWidth;
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

        // Use smooth scroll to snap to the calculated, clamped position
        sliderElement.scrollTo({
          left: targetScrollLeft,
          behavior: 'smooth' // Native smooth scroll for snapping
        });

        // NOTE: The original SliderComponent's 'scroll' listener should automatically
        // update buttons/pagination during the smooth scroll animation.
      }
    }
    // Update UI logic (button states, pagination) should ideally still be handled
    // by the original theme's SliderComponent listening to 'scroll' events.
    // If not, you might need to manually trigger its update method here or after scroll ends.
  }

  sliderElement.addEventListener('mouseup', finishDrag);
  sliderElement.addEventListener('mouseleave', finishDrag);

  // Click prevention (Capture phase)
  sliderElement.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // --- Mobile Touch Scroll ---
  // By default, with overflow-x: auto and NO touch event listeners calling preventDefault,
  // native touch scrolling should work. Ensure no other scripts or CSS
  // (like touch-action: none) are interfering.
  // We are *not* adding touchstart/touchmove/touchend listeners here to preserve native behavior.
}







